import React, { useState } from 'react';
import { ReactComponent as SettingsLogo } from 'src/Images/icons/common/settings.svg';
import { ReactComponent as CalendarLogo } from 'src/Images/icons/common/calendar.svg';
import { ReactComponent as NineDotsLogo } from 'src/Images/icons/navbar/nine-dots.svg';
import { ReactComponent as NotificationLogo } from 'src/Images/icons/navbar/notification.svg';
import AccountPopover from 'src/components/Layout/AccountPopover';
import ProductPopover from 'src/components/ProductPopover';
import 'src/style/footer.css';
import { useNavigate, useLocation } from 'react-router-dom';
import getColorCode from 'src/utils/GetThemeColor';
import { useSelector } from 'react-redux';

export default function MobileFooter() {
  const navigate = useNavigate();
  const location = useLocation();
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [productPopoverAnchor, setProductPopoverAnchor] = useState(null);

  const toggleProductPopover = (event) => {
    setProductPopoverAnchor(productPopoverAnchor ? null : event.currentTarget);
  };

  const handleSettingsClick = () => {
    if (location.pathname === '/settings') {
      navigate(-1);
    } else {
      navigate('/settings');
    }
  };

  return (
    <div className="mobile-footer-container">
      <NotificationLogo
        className="icon-size-lg"
        color={getColorCode(themeColor)}
      />

      <CalendarLogo className="icon-size-lg" color={getColorCode(themeColor)} />

      <button
        aria-label="Open product launcher"
        className="icon-btn-none"
        onClick={toggleProductPopover}
      >
        <NineDotsLogo
          className="icon-size-lg"
          color={getColorCode(themeColor)}
        />
      </button>
      <ProductPopover
        toggleProductPopover={() => setProductPopoverAnchor(null)}
        openProductPopover={productPopoverAnchor}
      />

      <SettingsLogo className="icon-size-lg" onClick={handleSettingsClick} />

      <AccountPopover />
    </div>
  );
}
